<template>
  <div
    class="list-section"
    :class="sectionClasses"
    role="presentation"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { cx } from '@/helpers'

defineOptions({ name: 'ListSection' })

const props = defineProps({
  side: { type: Boolean, default: false },
  avatar: { type: Boolean, default: false },
  top: { type: Boolean, default: false }
})

const sectionClasses = computed(() => cx(
  props.side && 'is-side',
  props.avatar && 'is-avatar',
  props.top && 'is-top',
  !props.side && !props.avatar && !props.top && 'is-main'
))
</script>

<style scoped>
@reference "#app-styles.css";

.list-section {
  @apply flex flex-col justify-center items-stretch min-w-0 max-w-full;
  @apply grow-10000 shrink basis-0;

  &.is-side,
  &.is-avatar {
    @apply flex-none items-start pr-sm;
  }
  &.is-side { @apply ink-subtle; }
  &.is-avatar { @apply min-w-14 text-inherit; }
  &.is-top { @apply justify-start justify-items-start; }
}
</style>
